<template>
  <div v-if="dataPending">
    <v-btn loading color="success">
      <v-icon left>
        add
      </v-icon>
      Pick Up
    </v-btn>
  </div>
  <div v-else>
    <div v-if="shift.pickupable">
      <v-tooltip top>
        <template slot="activator">
          <v-dialog :disabled="!canPickUp" v-model="pickUpDialog" max-width="290">
          <v-btn
            :disabled="!canPickUp"
            slot='activator'
            color='success'
          >
            <v-icon left v-if="!canPickUp">
              remove_circle
            </v-icon>
            <v-icon v-else left>
              add
            </v-icon>
            {{ !canPickUp ? 'Cannot Pick Up' : 'Pick Up' }}
          </v-btn>
          <v-card>
            <v-card-title class="headline">Pick Up Shift?</v-card-title>
            <v-card-text>
              <p>
                {{ shift.shiftRole }}
                at {{ shift.location }}
                on {{ shift.startDatetime | moment("dddd, MMM Do [at] h:mma") }}
              </p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="grey" flat @click="pickUpDialog = false">Nevermind</v-btn>
              <v-btn color='success' small :loading="apiCallPending" @click="pickUp">
                Yes, I'll take it!
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <span>{{ restrictedMessage || "Pick Up Shift!" }}</span>
      </v-tooltip>
    </div>

    <div v-if="shift.userId === user.id">
      <v-btn block v-if="!shift.tradePending" disabled class="" color="success">
        Picked up!
      </v-btn>
      <v-btn block v-if="shift.tradePending && !shift.tradeApprovalPending" color="primary">
        <v-icon left>
          sync
        </v-icon>
        On trade offer...
      </v-btn>
      <v-btn block v-if="shift.tradeApprovalPending" color="warning">
        Trade Pending Manager Approval
      </v-btn>
    </div>

    <div v-if="shift.userId && shift.userId != user.id">
      <v-btn block v-if="!shift.tradePending" disabled class="" color="success">
        Already Claimed
      </v-btn>
      <v-btn block v-if="shift.tradeApprovalPending" color="warning">
        Trade Pending Manager Approval
      </v-btn>
      <v-dialog v-if="shift.tradePending && !shift.tradeApprovalPending" v-model="tradeDialog" max-width="290">
        <v-btn
          block
          slot='activator'
          color='success'
        >
          <v-icon left>
            add
          </v-icon>
          Pick Up via Trade
        </v-btn>
        <v-card>
          <v-card-title class="headline">Trade Shift?</v-card-title>
          <v-card-text>
            <p>
              {{ shift.workerName }} Offered this shift up for trade. If you take this trade, your manager will need to approve it first.
            </p>
            <p>
              {{ shift.shiftRole }}
              at {{ shift.location }}
              on {{ shift.startDatetime | moment("dddd, MMM Do [at] h:mma") }}
              <ul>
                <li v-if="shift.hasTravelBonus">
                  {{ shift.travelBonusAmount }} travel bonus
                </li>
                <li v-if="shift.hasCallInBonus">
                  {{ shift.callInBonusAmount }} call-in bonus
                </li>
                <li v-if="shift.hasStraightBonus">
                  {{ shift.straightBonusAmount }} straight bonus
                </li>
              </ul>
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" flat @click="tradeDialog = false">Nevermind</v-btn>
            <v-btn color='success' small :loading="apiCallPending" @click="trade">
              Yes, I'll take it!
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: [
    'shift',
    'user'
  ],
  components: {
  },
  computed: {
    exampleComputed: function () {
      return this.example
    },
    dataPending: function () {
      if (!this.blackoutPending) {
        return false
      } else {
        return true
      }
    },
  },
  created () {
    this.setUp()
  },
  watch: {
  },
  data: function () {
    return {
      canPickUp: false,
      restrictedMessage: '',
      blackoutPending: true,
      skillsPending: true,
      pickUpDialog: false,
      tradeDialog: false,
      apiCallPending: false,
    }
  },
  methods: {
    trade () {
      this.apiCallPending = true
      this.$store.dispatch('shifts/trade', {
        shiftId: this.shift.id,
        tradeAcceptUserId: this.user.id
      })
      .finally(res => {
        this.apiCallPending = false
        this.tradeDialog = false
        this.$store.dispatch('shifts/getShift', this.shift.id).then(shift =>
          {
            this.shift = shift
          },
          error => {
            console.log(error)
        })
      })
    },
    pickUp () {
      this.apiCallPending = true
      this.$store.dispatch('shifts/pickUp', {
        shiftId: this.shift.id,
        userId: this.user.id,
      }).finally(res => {
        this.apiCallPending = false
        this.pickUpDialog = false
        this.$store.dispatch('shifts/getShift', this.shift.id).then(shift =>
          {
            this.shift = shift
          },
          error => {
            console.log(error)
        })
      })
    },
    setUp () {
      this.$store.dispatch('shifts/checkRestricted', { shiftId: this.shift.id, userid: this.user.id })
      .then(res => {
        this.blackoutPending = false
        this.canPickUp = res.verdict
        this.restrictedMessage = res.message
      })
      .catch(res => {
        this.blackoutPending = false
        this.canPickUp = true
        console.log('Something went wrong checking restrictions')
      })
    },
  },
}
</script>

<style scoped>
</style>
